import { render } from "./ObjectImport.vue?vue&type=template&id=6a88cff4"
import script from "./ObjectImport.vue?vue&type=script&lang=js"
export * from "./ObjectImport.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.22.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__